import { render } from "./CxReset.vue?vue&type=template&id=37d36ea5&scoped=true&ts=true"
import script from "./CxReset.vue?vue&type=script&lang=ts"
export * from "./CxReset.vue?vue&type=script&lang=ts"

import "./CxReset.vue?vue&type=style&index=0&id=37d36ea5&lang=less&scoped=true"

import exportComponent from "C:\\hexagon_develop\\hexagon_develop\\conx-ui\\microfrontends\\conx-ui-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d36ea5"]])

export default __exports__